import axios from "axios";

export default (prefix: string[]) =>
  ({ dispatch, getState }) =>
  (next: any) =>
  (action: any) => {
    // if (isEmpty(action)) return null;

    if (typeof action === "function") return action(dispatch, getState);

    if (!action.types) return next(action);

    const { types, method, url, data, params, files, ...rest } = action;
    next({ ...rest, type: types });

    return axios({ ...action, url: `/${prefix.join("/")}/${url}` })
      .then(({ data: result, status }) => {
        next({
          ...rest,
          result,
          status,
          type: `${types}Success`,
        });
        return Promise.resolve({ result, status });
      })
      .catch(({ response: { data: error, status } }) => {
        next({
          ...rest,
          error,
          status,
          type: `${types}Failure`,
        });
        return Promise.reject(error);
      });
  };
